import { useSelector } from "react-redux";
import UserProfile from "../components/Profile/UserProfile";

import StartingPageContent from "../components/StartingPage/StartingPageContent";
const ProfilePage = () => {
  const user = useSelector((state) => state.auth.user);
  const isInputer = user?.role === "ROLE_INPUTER" ? true : false;
  return (
    <StartingPageContent back={!isInputer} pageName="Profili">
      <UserProfile />
    </StartingPageContent>
  );
};

export default ProfilePage;
